import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { actions } from 'src/actions';
import { IntlProvider } from 'src/i18n/IntlProvider';
import { persistor, store } from 'src/utils/store';

//import 'antd/dist/antd.min.css';
import 'src/styles/global.css';
import 'src/styles/theme.css';

import { NotificationsProvider } from './NotificationsProvider';

interface Props {
  children: React.ReactNode;
}

// Runs after rehydration, before the app renders. A persisted `isLoggedIn`
// of `null` (a transient sign-in-in-progress state that got saved) would
// otherwise hang the app on <Preloader/> forever — reset it to signed-out.
const handleBeforeLift = () => {
  if (store.getState().access.isLoggedIn === null) {
    store.dispatch(
      actions.api.access.signOut.done({ result: { status: true } })
    );
  }
};

export const Provider: React.FC<Props> = ({ children }) => (
  <ReduxProvider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
      onBeforeLift={handleBeforeLift}
    >
      <IntlProvider>
        <NotificationsProvider>{children}</NotificationsProvider>
      </IntlProvider>
    </PersistGate>
  </ReduxProvider>
);
